module.exports = __webpack_public_path__ + "static/media/polygon-comments.f59f4b7e.svg";